// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type CancelManagerChangeReservationMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type CancelManagerChangeReservationMutation = { __typename?: 'Mutation' } & Pick<
  Types.Mutation,
  'cancelManagerChangeReservation'
>;

export const CancelManagerChangeReservationDocument = /*#__PURE__*/ gql`
    mutation CancelManagerChangeReservation($id: ID!) {
  cancelManagerChangeReservation(id: $id)
}
    `;
export type CancelManagerChangeReservationMutationFn = Apollo.MutationFunction<
  CancelManagerChangeReservationMutation,
  CancelManagerChangeReservationMutationVariables
>;

/**
 * __useCancelManagerChangeReservationMutation__
 *
 * To run a mutation, you first call `useCancelManagerChangeReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelManagerChangeReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelManagerChangeReservationMutation, { data, loading, error }] = useCancelManagerChangeReservationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelManagerChangeReservationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelManagerChangeReservationMutation,
    CancelManagerChangeReservationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CancelManagerChangeReservationMutation, CancelManagerChangeReservationMutationVariables>(
    CancelManagerChangeReservationDocument,
    options,
  );
}
export type CancelManagerChangeReservationMutationHookResult = ReturnType<
  typeof useCancelManagerChangeReservationMutation
>;
export type CancelManagerChangeReservationMutationOptions = Apollo.BaseMutationOptions<
  CancelManagerChangeReservationMutation,
  CancelManagerChangeReservationMutationVariables
>;
